import { CalendarDots } from '@phosphor-icons/react';
import React, { useState } from 'react';
import DateRangePicker, { DateRange, RangeType } from 'rsuite/DateRangePicker';
import 'rsuite/DateRangePicker/styles/index.css';
import { datePickerRanges } from './ranges';
import './dateRangePickerStyles.css';
import useReportingContext from 'hooks/context/reporting-context';
import dayjs from 'dayjs';

interface DatePickerProps {
  defaultDateRange?: string;
  value: DateRange | null;
  onChange: (dates: DateRange | undefined) => void;
}

// customize colours in Globalstyles.tsx (:root)
const DatePicker: React.FC<DatePickerProps> = ({ value, onChange }) => {
  const { filters } = useReportingContext();
  const [tempValue, setTempValue] = useState<DateRange | null>(value);

  return (
    <DateRangePicker
      format="dd-MM-yyyy"
      placement="bottomEnd"
      value={tempValue}
      placeholder={`${dayjs(filters.start_date).format('DD-MM-YYYY')} - ${dayjs(
        filters.end_date
      ).format('DD-MM-YYYY')}`}
      caretAs={CalendarDots}
      isoWeek
      ranges={datePickerRanges}
      onChange={(val) => setTempValue(val)} // use the temporary value state as a buffer for the user before passing it along to the parent component
      onOk={(val) => {
        if (val && val[0] && val[1]) onChange?.(val);
      }}
      onClean={() => {
        setTempValue(null);
        onChange(undefined);
      }}
      onShortcutClick={(range: RangeType) => {
        setTempValue(range.value as DateRange);
        onChange?.(range.value as DateRange);
      }}
    />
  );
};

export default DatePicker;
